(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["konhill-all-day-comfort"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const activeTab = (tab, focus = false) => {
      const root = tab.closest('.khc-comfort');
      if (!root) return;
      root.querySelectorAll('.khc-comfort__tab').forEach((item) => {
        const selected = item === tab;
        item.classList.toggle('is-active', selected);
        item.setAttribute('aria-selected', String(selected));
        item.tabIndex = selected ? 0 : -1;
      });
      root.querySelectorAll('.khc-comfort__panel').forEach((panel) => {
        panel.hidden = panel.id !== tab.getAttribute('aria-controls');
      });
      if (focus) tab.focus();
    };
    const updateButton = (video) => {
      const button = video.parentElement.querySelector('[data-khc-play-button]');
      if (!button) return;
      const playing = !video.paused;
      button.setAttribute('aria-label', playing ? 'Pause video' : 'Play video');
      button.title = playing ? 'Pause video' : 'Play video';
      button.querySelector('span').textContent = playing ? 'Ⅱ' : '▶';
    };
    const loadVideo = (video) => {
      if (video.dataset.loaded === 'true') return;
      const url = video.dataset.videoSrc;
      if (!url) return;
      video.src = url;
      video.dataset.loaded = 'true';
      video.load();
    };
    const motionReduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const saveData = navigator.connection && navigator.connection.saveData;
    const observer = 'IntersectionObserver' in window ? new IntersectionObserver((entries) => {
      entries.forEach(({ target: video, isIntersecting }) => {
        if (isIntersecting) {
          loadVideo(video);
          if (video.dataset.manual !== 'paused' && (video.dataset.manual === 'playing' || (video.dataset.autoplay === 'true' && !motionReduced && !saveData))) {
            const task = video.play();
            if (task && task.catch) task.catch(() => updateButton(video));
          }
        } else {
          video.pause();
        }
        updateButton(video);
      });
    }, { rootMargin: '120px 0px', threshold: 0 }) : null;
    const init = (scope) => {
      const videos = [];
      if (scope.matches && scope.matches('.khc-comfort__video')) videos.push(scope);
      scope.querySelectorAll('.khc-comfort__video').forEach((video) => videos.push(video));
      videos.forEach((video) => {
        if (video.dataset.khcInitialized === 'true') return;
        video.dataset.khcInitialized = 'true';
        video.addEventListener('play', () => updateButton(video));
        video.addEventListener('pause', () => updateButton(video));
        video.addEventListener('ended', () => updateButton(video));
        if (observer) observer.observe(video);
        else {
          loadVideo(video);
          if (video.dataset.autoplay === 'true' && !motionReduced && !saveData) {
            const task = video.play();
            if (task && task.catch) task.catch(() => updateButton(video));
          }
        }
      });
    };
    document.addEventListener('click', (event) => {
      const tab = event.target.closest('.khc-comfort__tab');
      if (tab) { activeTab(tab); return; }
      const button = event.target.closest('[data-khc-play-button]');
      if (!button) return;
      const video = button.parentElement.querySelector('.khc-comfort__video');
      if (!video) return;
      loadVideo(video);
      if (video.paused) {
        video.dataset.manual = 'playing';
        const task = video.play();
        if (task && task.catch) task.catch(() => updateButton(video));
      } else {
        video.dataset.manual = 'paused';
        video.pause();
      }
      updateButton(video);
    });
    document.addEventListener('keydown', (event) => {
      const tab = event.target.closest('.khc-comfort__tab');
      if (!tab) return;
      if (!['ArrowRight', 'ArrowLeft', 'Home', 'End'].includes(event.key)) return;
      const tabs = [...tab.parentElement.querySelectorAll('.khc-comfort__tab')];
      if (!tabs.length) return;
      event.preventDefault();
      let index = tabs.indexOf(tab);
      if (event.key === 'Home') index = 0;
      else if (event.key === 'End') index = tabs.length - 1;
      else index = (index + (event.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length;
      activeTab(tabs[index], true);
    });
    document.addEventListener('shopify:section:load', (event) => init(event.target));
    document.addEventListener('shopify:section:unload', (event) => {
      event.target.querySelectorAll('.khc-comfort__video').forEach((video) => {
        video.pause();
        if (observer) observer.unobserve(video);
      });
    });
    document.addEventListener('shopify:block:select', (event) => {
      const root = event.target.closest('.khc-comfort');
      if (!root) return;
      const tab = [...root.querySelectorAll('.khc-comfort__tab')].find((item) => item.dataset.blockId === event.detail.blockId);
      if (tab) activeTab(tab);
    });
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document), { once: true });
    else init(document);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tiosebon-offers"] && !Shopify.designMode) return;
  try {
    
(() => {
  function init(root) {
    if (root.dataset.khReady) return;
    root.dataset.khReady = 'true';
    const button = root.querySelector('[data-kh-copy]');
    const label = root.querySelector('[data-kh-copy-label]');
    if(!button||!label)return;
    let timer;
    button.addEventListener('click', async () => {
      try {
        await navigator.clipboard.writeText(button.dataset.khCopy);
        label.textContent = 'COPIED ✓';
        clearTimeout(timer);
        timer = setTimeout(() => { label.textContent = 'USE CODE'; }, 2200);
      } catch { label.textContent = 'YOUR CODE'; }
    });
  }
  document.querySelectorAll('[data-kh-welcome]').forEach(init);
  if (!window.khWelcomeOfferBound) {
    window.khWelcomeOfferBound = true;
    document.addEventListener('shopify:section:load', event => {
      event.target.querySelectorAll('[data-kh-welcome]').forEach(init);
    });
  }
})();


(() => {
  if (window.khPairOfferSectionV1) { window.khPairOfferSectionV1.scan(); return; }
  let sequence = 0;
  function mount(component) {
    if (component.dataset.khOfferReady) return;
    component.dataset.khOfferReady = 'true';
    const owner = component.closest('.shopify-section') || component.closest('[data-kh-welcome]') || component.parentElement;
    const find = selector => component.querySelector(selector);
    const slots = [...component.querySelectorAll('[data-kh-dock-slot]')];
    const modalSlots = [...component.querySelectorAll('[data-kh-modal-slot]')];
    const links = [...component.querySelectorAll('[data-kh-browse]')];
    const choices = [...component.querySelectorAll('[data-kh-dock-product]')];
    const products = choices.map(card => ({name:card.dataset.name,price:Number(card.dataset.price),image:card.dataset.image,url:card.dataset.url,handle:card.dataset.handle,variantCount:Number(card.dataset.variantCount)}));
    const selected = [null, null];
    const sheet = find('[data-kh-drawer]');
    const dock = find('[data-kh-dock]');
    const heading = find('[data-kh-grid-title]');
    const expandButton=find('[data-kh-expand]');
    const startAdd=find('[data-kh-start-add]');
    const confirmAdd=find('[data-kh-confirm]');
    const optionsPanel=find('[data-kh-options]');
    const catalog=find('[data-kh-catalog]');
    const message=find('[data-kh-options-message]');
    const cartLink=find('[data-kh-view-cart]');
    const cache=new Map();
    const requests=new Set();
    const variants=[null,null];
    const optionModels=[null,null];
    let mode='styles',loadGeneration=0,submitting=false,uncertain=false,lastAdded='',scrollFrame=0;
    let scrollAnchor=window.scrollY;
    const root=(window.Shopify?.routes?.root||component.dataset.root||'/').replace(/\/?$/,'/');
    const cartURL=component.dataset.cartUrl||root+'cart';
    cartLink.href=cartURL;
    const prefix = 'kh-pair-offer-section-v1-' + (++sequence);
    sheet.id = prefix;
    find('[data-kh-expanded]').id=prefix+'-dock';expandButton.setAttribute('aria-controls',prefix+'-dock');
    find('[data-kh-drawer-title]').id = prefix + '-title';
    sheet.setAttribute('aria-labelledby',prefix + '-title');
    heading.id = prefix + '-choices';
    slots.forEach(slot=>slot.setAttribute('aria-controls',sheet.id));
    modalSlots.forEach(slot=>slot.setAttribute('aria-controls',heading.id));
    let format;
    try {format=new Intl.NumberFormat(document.documentElement.lang||'en',{style:'currency',currency:component.dataset.currency||'USD'});}
    catch {format=new Intl.NumberFormat('en',{style:'currency',currency:'USD'});}
    const money=value=>format.format(value/100);
    const quantum=Math.pow(10,Math.max(0,2-format.resolvedOptions().maximumFractionDigits));
    const discounted=price=>Math.round(price*.75/quantum)*quantum;
    const reducedMotion=window.matchMedia?window.matchMedia('(prefers-reduced-motion: reduce)').matches:true;
    let active=0;
    let hydrated=false;
    let previousOverflow=null;
    let observer;
    let destroyed=false;
    function measure(){if(!component.classList.contains('is-compact'))component.style.setProperty('--kh-dock-height',Math.ceil(dock.getBoundingClientRect().height||165)+'px');}
    function disposeOptions(){optionModels.forEach(model=>model?.dispose?.());}
    function restoreScroll(){if(previousOverflow!==null){document.body.style.overflow=previousOverflow;previousOverflow=null;}}
    function closeSheet(restoreFocus=true){
      if(submitting&&!destroyed)return;
      loadGeneration++;disposeOptions();
      if(sheet.open)sheet.close();
      restoreScroll();
      slots.forEach(slot=>slot.setAttribute('aria-expanded','false'));
      if(restoreFocus&&!destroyed)(mode==='options'?startAdd:slots[active]).focus({preventScroll:true});
    }
    function activate(index,scroll=false){
      active=index;
      modalSlots.forEach((slot,i)=>slot.setAttribute('aria-pressed',String(i===active)));
      choices.forEach((choice,i)=>choice.setAttribute('aria-pressed',String(selected[active]===i)));
      heading.textContent=active===0?'Choose your first pair':'Choose your second pair';
      slots.forEach((slot,i)=>slot.setAttribute('aria-expanded',String(sheet.open&&i===active)));
      if(scroll)heading.scrollIntoView?.({block:'nearest',behavior:reducedMotion?'auto':'smooth'});
    }
    function openDialog(){
      component.classList.remove('is-compact');scrollAnchor=window.scrollY;
      if(!sheet.open){sheet.showModal();previousOverflow=document.body.style.overflow;document.body.style.overflow='hidden';find('.kh-drawer-body').scrollTop=0;}
    }
    function stylesMode(){
      mode='styles';loadGeneration++;disposeOptions();
      optionsPanel.hidden=true;catalog.hidden=false;
      find('[data-kh-back]').hidden=true;confirmAdd.hidden=true;cartLink.hidden=true;find('[data-kh-done]').hidden=false;
      find('[data-kh-drawer-title]').textContent='Your two-pair offer';
      update();
    }
    function openSheet(index){
      stylesMode();
      if(!hydrated){
        component.querySelectorAll('[data-kh-drawer-src]').forEach(image=>{image.src=image.dataset.khDrawerSrc;image.removeAttribute('data-kh-drawer-src');});
        hydrated=true;
      }
      openDialog();
      activate(index);
      modalSlots[index].focus({preventScroll:true});
    }
    function imageFor(product,size){
      const image=document.createElement('img');
      image.src=product.image;
      image.alt=product.name;
      image.width=size;
      image.height=size;
      image.decoding='async';
      return image;
    }
    function update(){
      const picked=selected.filter(index=>index!==null);
      const complete=picked.length===2;
      const prices=selected.map((index,i)=>index===null?0:(variants[i]?.price??products[index].price));
      const original=prices.reduce((a,b)=>a+b,0);
      const total=prices.reduce((a,b)=>a+discounted(b),0);
      selected.forEach((productIndex,index)=>{
        if(productIndex===null)return;
        const product={...products[productIndex],price:prices[index]};
        const card=slots[index].closest('.kh-dock-card');
        if(slots[index].dataset.productIndex!==String(productIndex)){
          slots[index].replaceChildren(imageFor(product,160));
          slots[index].classList.add('is-selected');
          slots[index].dataset.productIndex=String(productIndex);
          slots[index].setAttribute('aria-label','Change pair '+(index+1)+': '+product.name);
          card.querySelector('[data-kh-card-name]').textContent=product.name;
          card.querySelector('[data-kh-card-caption]').hidden=false;
          links[index].href=product.url;
          links[index].hidden=false;
          links[index].setAttribute('aria-label','View '+product.name+' (opens in a new tab)');
          find('[data-kh-mini="'+index+'"]').replaceChildren(imageFor(product,68));
          modalSlots[index].querySelector('[data-kh-modal-image]').replaceChildren(imageFor(product,96));
          modalSlots[index].querySelector('[data-kh-modal-name]').textContent=product.name;
          modalSlots[index].querySelector('[data-kh-modal-change]').textContent='Change';
        }
        card.querySelector('[data-kh-selected-price]').textContent=money(complete?discounted(product.price):product.price);
        const price=modalSlots[index].querySelector('[data-kh-modal-price]');
        price.replaceChildren();
        if(complete){
          const old=document.createElement('del');old.textContent=money(product.price);
          const current=document.createElement('strong');current.textContent=money(discounted(product.price));
          price.append(old,current);
        }else{price.textContent=money(product.price);}
      });
      find('[data-kh-dock-total]').textContent=complete?money(total):'—';
      find('[data-kh-compact-total]').textContent=complete?money(total):'—';
      startAdd.hidden=!complete;
      find('[data-kh-popup-add]').hidden=!complete||mode!=='styles';
      if(mode==='options')syncSubmit();
      find('[data-kh-drawer-step]').textContent=picked.length+' / 2 pairs selected';
      links.forEach((link,i)=>{if(selected[i]!==null){const product=products[selected[i]];link.href=product.url+(variants[i]?(product.url.includes('?')?'&':'?')+'variant='+variants[i].id:'');}});
      find('[data-kh-subtotal-label]').textContent=picked.length===1?'Selected subtotal':'Original total';
      find('[data-kh-modal-original]').textContent=picked.length?money(original):'—';
      find('[data-kh-modal-savings]').textContent=complete?'−'+money(original-total):'—';
      find('[data-kh-modal-total]').textContent=complete?money(total):'—';
      find('[data-kh-modal-status]').textContent=complete?'Your two-pair savings are ready.':picked.length===1?'Choose one more pair to unlock 25% off both.':'Choose two pairs to reveal your offer.';
      find('[data-kh-modal-footer]').textContent=complete?'2 pairs · You save '+money(original-total):picked.length===1?'Choose your second pair.':'Choose two styles to see your savings.';
      activate(active);
      measure();
    }
    function compact(){
      if(destroyed||sheet.open||component.classList.contains('is-compact'))return;
      if(Math.abs(window.scrollY-scrollAnchor)<(Number(component.dataset.collapseDistance)||40))return;
      const focused=dock.contains(document.activeElement);
      component.classList.add('is-compact');if(focused)expandButton.focus({preventScroll:true});
    }
    function onScroll(){
      if(scrollFrame||component.classList.contains('is-compact')||sheet.open)return;
      scrollFrame=window.requestAnimationFrame(()=>{scrollFrame=0;compact();});
    }
    expandButton.addEventListener('click',()=>{
      component.classList.remove('is-compact');scrollAnchor=window.scrollY;measure();
      (selected.every(i=>i!==null)?startAdd:slots[selected[0]===null?0:1]).focus({preventScroll:true});
    });
    function say(text,error=false){message.textContent=text;message.classList.toggle('is-error',error);}
    function signature(){return variants.every(Boolean)?variants.map(v=>v.id).join(':'):'';}
    function syncSubmit(){
      const valid=variants.every(v=>v&&v.available&&!v.requires_selling_plan)&&!optionModels.some(model=>model?.busy);
      confirmAdd.disabled=submitting||uncertain||!valid||lastAdded===signature();
      confirmAdd.textContent=submitting?'Adding…':lastAdded&&lastAdded===signature()?'Added to cart':'Add 2 pairs to cart';
    }
    async function getOptionState(product,ids=[]){
      const key=product.handle+'|options|'+ids.join(','),now=Date.now(),cached=cache.get(key);
      if(cached&&now-cached.time<180000)return cached.promise;
      const controller=new AbortController();requests.add(controller);
      const timeout=setTimeout(()=>controller.abort(),15000);
      const promise=(async()=>{
        try{
          const url=new URL(root+'products/'+encodeURIComponent(product.handle),location.origin);
          url.searchParams.set('section_id','tiosebon-offers');
          if(ids.length)url.searchParams.set('option_values',ids.join(','));
          const response=await fetch(url.pathname+url.search,{credentials:'same-origin',headers:{Accept:'text/html'},signal:controller.signal});
          if(!response.ok)throw Error('Product options could not be loaded. Please reload options.');
          const html=await response.text(),match=html.match(/<script\b[^>]*data-kh-option-state[^>]*>([\s\S]*?)<\/script>/i);
          if(!match)throw Error('Please save the complete section as sections/tiosebon-offers.liquid, then reload options.');
          const data=JSON.parse(match[1]);
          if(data.handle!==product.handle||!Array.isArray(data.options)||!data.options.length)throw Error('Product options are temporarily unavailable.');
          return data;
        }catch(error){cache.delete(key);throw error;}finally{clearTimeout(timeout);requests.delete(controller);}
      })();
      cache.set(key,{time:now,promise});return promise;
    }
    function deferredOptionsFor(initial,index){
      const product=products[selected[index]],box=make('fieldset','kh-option-pair');
      box.append(make('legend','', 'Pair '+(index+1)+' · '+product.name));
      const preview=make('div','kh-option-preview'),image=imageFor(product,112),price=make('strong','');preview.append(image,price);box.append(preview);
      const fields=make('div','kh-option-fields');box.append(fields);
      const state=make('p','kh-option-state');state.setAttribute('role','status');box.append(state);
      const retry=make('button','kh-retry','Retry options');retry.type='button';retry.hidden=true;box.append(retry);
      let current=initial,version=0,timer=0,disposed=false;
      const prior=variants[index];
      const chosen=initial.options.map((option,i)=>prior?.options[i]??(option.values.length===1?option.values[0].name:''));
      const selects=[];
      const model={box,selects,busy:false,dispose(){disposed=true;version++;clearTimeout(timer);}};
      optionModels[index]=model;
      initial.options.forEach((option,i)=>{
        const label=make('label','kh-option-field');label.append(make('span','',option.name));
        const select=make('select','');select.setAttribute('aria-label','Pair '+(index+1)+' '+option.name);select.required=true;
        select.dataset.khPair=String(index);select.dataset.khOption=String(i);
        const placeholder=make('option','','Select '+option.name);placeholder.value='';select.append(placeholder);
        option.values.forEach(value=>{const item=make('option','',value.name);item.value=value.name;select.append(item);});
        select.value=chosen[i];
        select.addEventListener('change',()=>{
          chosen[i]=select.value;version++;clearTimeout(timer);
          variants[index]=null;model.busy=true;retry.hidden=true;state.textContent='Checking availability…';update();
          timer=setTimeout(()=>resolve(version),140);
        });
        label.append(select);fields.append(label);selects.push(select);
      });
      function apply(data){
        current=data;
        const complete=chosen.every(Boolean),candidate=data.variant;
        const matches=complete&&candidate&&candidate.options.length===chosen.length&&candidate.options.every((value,i)=>value===chosen[i]);
        variants[index]=matches?candidate:null;
        if(data.requires_selling_plan)variants[index]=null;
        selects.forEach((select,i)=>{
          const values=data.options[i]?.values||[];
          [...select.options].forEach(option=>{
            if(!option.value)return;
            const value=values.find(value=>value.name===option.value);
            option.textContent=option.value+(value&&value.available===false?' — Sold out':'');
          });
        });
        state.textContent=!complete?'Select every option, including fit, for this pair.':!matches?'This combination is unavailable. Try a different size or fit.':candidate.requires_selling_plan||data.requires_selling_plan?'Choose a purchase plan on the product page.':candidate.available?'In stock · '+money(candidate.price)+' before offer':'Sold out — choose another option.';
        price.textContent=matches?money(discounted(candidate.price))+' estimated':'';
        const src=matches&&candidate.featured_image?.src||product.image;
        if(image.getAttribute('src')!==src)image.src=src;
        update();
      }
      async function resolve(token){
        const ids=current.options.map((option,i)=>{
          const value=option.values.find(value=>value.name===chosen[i])||option.values.find(value=>value.selected)||option.values[0];
          return value?.id;
        });
        try{
          if(ids.some(id=>id==null))throw Error('Could not read all product options. Please reload options.');
          const data=await getOptionState(product,ids);
          if(disposed||destroyed||token!==version||!sheet.open||mode!=='options'||optionModels[index]!==model)return;
          model.busy=false;retry.hidden=true;apply(data);
        }catch(error){
          if(disposed||destroyed||token!==version||optionModels[index]!==model)return;
          model.busy=false;variants[index]=null;
          state.textContent=error.name==='AbortError'?'Loading timed out. Retry these options.':error.message;
          retry.hidden=false;update();
        }
      }
      retry.addEventListener('click',()=>{version++;model.busy=true;retry.hidden=true;state.textContent='Checking availability…';update();resolve(version);});
      apply(initial);
      if(chosen.every(Boolean)&&!variants[index]){model.busy=true;syncSubmit();resolve(++version);}
      return box;
    }

    async function getProduct(product){
      if(product.variantCount>250)return getOptionState(product);
      const now=Date.now(),cached=cache.get(product.handle);
      if(cached&&now-cached.time<180000)return cached.promise;
      const controller=new AbortController();requests.add(controller);
      const timeout=setTimeout(()=>controller.abort(),15000);
      const promise=(async()=>{
        try{
          const response=await fetch(root+'products/'+encodeURIComponent(product.handle)+'.js',{credentials:'same-origin',headers:{Accept:'application/json'},signal:controller.signal});
          if(!response.ok)throw Error('Product options are temporarily unavailable.');
          const data=await response.json();
          if(!Array.isArray(data.variants)||!data.variants.length)throw Error('No product options are available.');
          if(data.variants.length>=250)return getOptionState(product);
          return data;
        }catch(error){cache.delete(product.handle);throw error;}finally{clearTimeout(timeout);requests.delete(controller);}
      })();
      cache.set(product.handle,{time:now,promise});return promise;
    }
    function make(tag,className,text){const element=document.createElement(tag);if(className)element.className=className;if(text!==undefined)element.textContent=text;return element;}
    function optionsFor(data,index){
      if(data.deferred)return deferredOptionsFor(data,index);
      const product=products[selected[index]],box=make('fieldset','kh-option-pair');
      box.append(make('legend','', 'Pair '+(index+1)+' · '+product.name));
      const preview=make('div','kh-option-preview'),image=imageFor(product,112),price=make('strong','');preview.append(image,price);box.append(preview);
      const fields=make('div','kh-option-fields');box.append(fields);
      const state=make('p','kh-option-state');state.setAttribute('role','status');box.append(state);
      const options=data.options.map((option,i)=>({name:typeof option==='string'?option:option.name,values:option.values?.length?option.values:[...new Set(data.variants.map(v=>v.options[i]))]}));
      const defaultOnly=options.length===1&&options[0].name==='Title'&&options[0].values.length===1&&options[0].values[0]==='Default Title';
      const prior=variants[index];
      const chosen=options.map((option,i)=>prior?.options[i]??(option.values.length===1?option.values[0]:''));
      const selects=[];
      if(!defaultOnly)options.forEach((option,i)=>{
        const label=make('label','kh-option-field');label.append(make('span','',option.name));
        const select=make('select','');select.setAttribute('aria-label','Pair '+(index+1)+' '+option.name);select.required=true;
        const placeholder=make('option','','Select '+option.name);placeholder.value='';select.append(placeholder);
        option.values.forEach(value=>{const item=make('option','',value);item.value=value;select.append(item);});
        select.value=chosen[i];select.dataset.khOption=String(i);select.dataset.khPair=String(index);
        select.addEventListener('change',()=>{chosen[i]=select.value;refresh();});
        label.append(select);fields.append(label);selects.push(select);
      });
      const model={box,selects};optionModels[index]=model;
      function refresh(){
        variants[index]=chosen.every(Boolean)?data.variants.find(v=>v.options.every((value,i)=>value===chosen[i]))||null:null;
        const variant=variants[index];
        selects.forEach((select,i)=>[...select.options].forEach(option=>{
          if(!option.value)return;
          const exists=data.variants.some(v=>v.options[i]===option.value&&chosen.every((value,j)=>j>=i||!value||v.options[j]===value));
          const available=data.variants.some(v=>v.available&&!v.requires_selling_plan&&v.options[i]===option.value&&chosen.every((value,j)=>j>=i||!value||v.options[j]===value));
          option.disabled=!exists;option.textContent=option.value+(exists&&!available?' — Sold out':'');
        }));
        state.textContent=!chosen.every(Boolean)?'Select every option for this pair.':!variant?'This combination is unavailable.':variant.requires_selling_plan||data.requires_selling_plan?'Choose a purchase plan on the product page.':variant.available?'In stock · '+money(variant.price)+' before offer':'Sold out — choose another option.';
        if(data.requires_selling_plan&&variant)variants[index]=null;
        price.textContent=variant?money(discounted(variant.price))+' estimated':'';
        let src=variant?.featured_image?.src||product.image;
        try{const imageURL=new URL(src,location.href);if(imageURL.hostname==='cdn.shopify.com'){imageURL.searchParams.set('width','224');src=imageURL.href;}}catch{}
        if(image.getAttribute('src')!==src)image.src=src;
        links[index].href=variant?product.url+(product.url.includes('?')?'&':'?')+'variant='+variant.id:product.url;
        update();
      }
      refresh();return box;
    }
    async function openOptions(){
      if(destroyed||submitting||selected.some(i=>i===null))return;
      disposeOptions();openDialog();mode='options';const generation=++loadGeneration;
      catalog.hidden=true;optionsPanel.hidden=false;find('[data-kh-popup-add]').hidden=true;find('[data-kh-back]').hidden=false;confirmAdd.hidden=false;find('[data-kh-done]').hidden=true;
      cartLink.hidden=!uncertain&&!(lastAdded&&lastAdded===signature());
      find('[data-kh-drawer-title]').textContent='Choose color, size & fit';
      find('[data-kh-options-pairs]').replaceChildren();find('[data-kh-retry]').hidden=true;
      optionsPanel.setAttribute('aria-busy','true');confirmAdd.disabled=true;say('Loading options for your selected pairs…');
      find('[data-kh-options-title]').focus({preventScroll:true});
      const snapshot=[...selected];
      try{
        const data=await Promise.all(snapshot.map(index=>getProduct(products[index])));
        if(destroyed||generation!==loadGeneration||!sheet.open)return;
        const boxes=data.map((product,index)=>optionsFor(product,index));
        find('[data-kh-options-pairs]').replaceChildren(...boxes);
        say(uncertain?'Please check your cart before adding these pairs again.':lastAdded===signature()?'Both pairs have been added to your cart.':'Choose all options, then add both pairs to your cart.');
        syncSubmit();
      }catch(error){
        if(destroyed||generation!==loadGeneration)return;
        say((error.name==='AbortError'?'Loading took too long. Please try again.':error.message)+' You can also use View product to choose options.',true);
        confirmAdd.disabled=true;find('[data-kh-retry]').hidden=false;
      }finally{if(generation===loadGeneration)optionsPanel.removeAttribute('aria-busy');}
    }
    async function addPairs(){
      if(destroyed||confirmAdd.disabled||submitting||uncertain)return;
      const items=[];
      variants.forEach(variant=>{const item=items.find(i=>i.id===variant.id);if(item)item.quantity++;else items.push({id:variant.id,quantity:1});});
      const controller=new AbortController();requests.add(controller);
      const timeout=setTimeout(()=>controller.abort(),20000);
      const addedKey=signature();submitting=true;syncSubmit();say('Adding your selected pairs…');
      find('[data-kh-back]').disabled=true;find('[data-kh-drawer-close]').disabled=true;
      optionModels.forEach(model=>model?.selects.forEach(select=>select.disabled=true));
      modalSlots.forEach(slot=>slot.disabled=true);
      try{
        const response=await fetch(root+'cart/add.js',{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items}),signal:controller.signal});
        const data=await response.json();
        if(!response.ok||data.status)throw Error(typeof data.description==='string'?data.description:'Your cart could not be confirmed.');
        if(destroyed)return;
        lastAdded=addedKey;cartLink.hidden=false;say('Both pairs were added. View your cart for the confirmed promotion and total.');
        find('[data-kh-modal-footer]').textContent='Added to cart · 2 pairs';
        document.dispatchEvent(new CustomEvent('kh:cart-added',{detail:{items:data.items||[]}}));
      }catch(error){
        if(destroyed)return;
        uncertain=true;cartLink.hidden=false;
        say((error.name==='AbortError'?'The request timed out.':error.message||'The connection was interrupted.')+' Please check your cart before trying again; some items may already have been added.',true);
      }finally{
        clearTimeout(timeout);requests.delete(controller);submitting=false;syncSubmit();find('[data-kh-back]').disabled=false;find('[data-kh-drawer-close]').disabled=false;
        optionModels.forEach(model=>model?.selects.forEach(select=>select.disabled=false));modalSlots.forEach(slot=>slot.disabled=false);
      }
    }
    startAdd.addEventListener('click',openOptions);
    find('[data-kh-popup-add]').addEventListener('click',openOptions);
    find('[data-kh-retry]').addEventListener('click',openOptions);
    find('[data-kh-back]').addEventListener('click',()=>{if(!submitting){stylesMode();heading.focus?.({preventScroll:true});}});
    confirmAdd.addEventListener('click',addPairs);
    slots.forEach((slot,index)=>slot.addEventListener('click',()=>openSheet(index)));
    modalSlots.forEach((slot,index)=>slot.addEventListener('click',()=>{if(!submitting){if(mode!=='styles')stylesMode();activate(index,true);}}));
    choices.forEach((choice,index)=>choice.addEventListener('click',()=>{
      if(submitting)return;
      selected[active]=index;variants[active]=null;optionModels[active]?.dispose?.();optionModels[active]=null;
      const empty=selected.findIndex(value=>value===null);
      if(empty>=0)active=empty;
      update();
      if(empty<0)find('[data-kh-offer-summary]').scrollIntoView?.({block:'nearest',behavior:reducedMotion?'auto':'smooth'});
    }));
    find('[data-kh-done]').addEventListener('click',()=>closeSheet());
    find('[data-kh-drawer-close]').addEventListener('click',()=>closeSheet());
    sheet.addEventListener('cancel',event=>{event.preventDefault();closeSheet();});
    sheet.addEventListener('close',()=>{scrollAnchor=window.scrollY;restoreScroll();slots.forEach(slot=>slot.setAttribute('aria-expanded','false'));});
    sheet.addEventListener('click',event=>{
      if(event.target!==sheet)return;
      const rect=sheet.getBoundingClientRect();
      if(event.clientY<rect.top||event.clientY>rect.bottom||event.clientX<rect.left||event.clientX>rect.right)closeSheet();
    });
    function unload(event){
      if(event.target===owner||event.target.contains(owner)){
        destroyed=true;
        closeSheet(false);
        observer?.disconnect();
        requests.forEach(controller=>controller.abort());requests.clear();cache.clear();
        window.removeEventListener('scroll',onScroll);if(scrollFrame)cancelAnimationFrame(scrollFrame);
        window.removeEventListener('resize',measure);
        component.remove();
        document.removeEventListener('shopify:section:unload',unload);
      }
    }
    document.body.append(component);
    component.hidden=false;
    update();
    if('ResizeObserver'in window){observer=new ResizeObserver(measure);observer.observe(dock);}
    window.addEventListener('resize',measure,{passive:true});
    window.addEventListener('scroll',onScroll,{passive:true});
    document.addEventListener('shopify:section:unload',unload);
  }
  function scan(scope=document){
    if(scope.matches?.('[data-kh-pair-offer-section-v1]'))mount(scope);
    scope.querySelectorAll('[data-kh-pair-offer-section-v1]').forEach(mount);
  }
  window.khPairOfferSectionV1={scan};
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>scan(),{once:true});
  else scan();
  document.addEventListener('shopify:section:load',event=>scan(event.target));
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["welcome-bundle-offer"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (customElements.get('welcome-edit-section')) return;
  const esc = value => String(value ?? '').replace(/[&<>"']/g, char => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[char]));
  const sourceURL = input => {
    const raw = typeof input === 'string' ? input : input?.src || input?.url || '';
    if (!raw) return '';
    try { const url = new URL(raw, location.href); return /^https?:$/.test(url.protocol) ? url.href : ''; } catch { return ''; }
  };
  const imageURL = (input, width=700) => {
    const src = sourceURL(input); if (!src) return '';
    const url = new URL(src);
    if (url.hostname.endsWith('shopify.com') || url.pathname.includes('/cdn/')) url.searchParams.set('width', String(width));
    return url.href;
  };
  const normalise = raw => {
    const variants = (raw.variants || []).map(v => ({...v,id:String(v.id),price:Math.max(0,Math.round(Number(v.price)||0)),options:(v.options || [v.option1,v.option2,v.option3].filter(x=>x!=null)).map(String)}));
    const options = (raw.options || []).map((o,i) => ({name:typeof o==='string'?o:String(o.name || `Option ${i+1}`),values:[...new Set(variants.map(v=>v.options[i]).filter(x=>x!=null))]}));
    const images = [...new Set((raw.images || []).map(sourceURL).filter(Boolean))];
    const featured = sourceURL(raw.featured_image);
    if(featured && !images.includes(featured)) images.unshift(featured);
    const product = {id:String(raw.id),title:String(raw.title || ''),handle:String(raw.handle || ''),options,variants,images};
    product.hasDefault = options.length===1 && variants.every(v=>v.options[0]==='Default Title');
    return product;
  };
  const purchasable = variant => Boolean(variant && variant.available && !variant.requires_selling_plan && Number(variant.quantity_rule?.min || 1)<=1 && Number(variant.quantity_rule?.increment || 1)===1 && (variant.quantity_rule?.max==null || Number(variant.quantity_rule.max)>=1));
  const isSize = name => /size|尺码|尺寸|talla|pointure|größe|taille/i.test(name);
  const matches = (variant, options, end=options.length) => options.slice(0,end).every((value,i)=>!value || variant.options[i]===value);
  const exactVariant = (product, options) => product?.variants.find(v=>purchasable(v) && v.options.length===options.length && options.every((value,i)=>value && v.options[i]===value));
  const changeOption = (product, oldOptions, index, value) => {
    const options=[...oldOptions]; options[index]=value;
    for(let i=index+1;i<product.options.length;i++) {
      const candidates=product.variants.filter(v=>purchasable(v)&&matches(v,options,i));
      if(!options[i] || !candidates.some(v=>v.options[i]===options[i])) options[i]=isSize(product.options[i].name)?'':candidates[0]?.options[i] || '';
    }
    return options;
  };
  const discountPrice = (price,rate) => price-Math.round(price*rate/100);
  const decodeCatalog = node => JSON.parse(node.dataset.encoding==='base64' ? new TextDecoder().decode(Uint8Array.from(atob(node.textContent.trim()),char=>char.charCodeAt(0))) : node.textContent);

  class WelcomeBundleBuilder extends HTMLElement {
    connectedCallback(){queueMicrotask(()=>{if(this.isConnected&&!this._started)this.init();});}
    disconnectedCallback(){this.life?.abort();this.productRequest?.abort();this.restoreScroll();this._started=false;}
    init(){
      const node=this.querySelector('[data-bb-catalog]'); if(!node)return;
      try{this.config=decodeCatalog(node);}catch{return;}
      this._started=true; this.life=new AbortController();
      this.config.sectionId=this.closest('[id^="shopify-section-"]')?.id.replace(/^shopify-section-/,'') || this.config.sectionId || '';
      const uniqueId='welcome-'+(globalThis.crypto?.randomUUID?.() || Math.random().toString(36).slice(2));
      this.querySelector('[data-bb-heading]').id=uniqueId+'-heading';this.setAttribute('aria-labelledby',uniqueId+'-heading');
      this.querySelector('[data-bb-dialog-title]').id=uniqueId+'-dialog-title';
      this.labels=this.config.labels;
      this.root=String(this.config.root || window.Shopify?.routes?.root || '/'); if(!this.root.endsWith('/'))this.root+='/';
      this.rates=(this.config.rates || [15,25,30]).slice(0,3).map(x=>Math.max(0,Math.min(100,Number(x)||0)));
      this.products=new Map((this.config.products || []).map(normalise).map(p=>[p.id,p]));
      this.next=this.config.next || ''; this.slots=[null]; this.useCode=Boolean(this.config.code); this.busy=false;this.uncertain=false;this.lastAdded='';this.activeIndex=0;this.detailProduct=null;this.galleryIndex=0;this.visitedPages=new Set();
      this.dialog=this.querySelector('[data-bb-dialog]');
      this.dialog.setAttribute('aria-labelledby',uniqueId+'-dialog-title');
      const signal=this.life.signal;
      this.addEventListener('click',event=>this.onClick(event),{signal});
      this.addEventListener('change',event=>this.onChange(event),{signal});
      this.addEventListener('input',event=>{if(event.target.matches('[data-bb-search]'))this.renderCatalog();},{signal});
      this.dialog.addEventListener('close',()=>{this.restoreScroll();this.restoreFocus();},{signal});
      this.dialog.addEventListener('cancel',()=>{this.productRequest?.abort();},{signal});
      this.dialog.addEventListener('click',event=>{if(event.target===this.dialog)this.closePicker();},{signal});
      this.dialog.addEventListener('keydown',event=>{if(event.target.closest('.bb-gallery')&&['ArrowLeft','ArrowRight'].includes(event.key)){event.preventDefault();this.moveGallery(event.key==='ArrowLeft'?-1:1);}},{signal});
      this.renderBoard();
    }
    t(key,vars={}){let value=this.labels[key]??key;for(const [name,replacement]of Object.entries(vars))value=value.replaceAll('{'+name+'}',String(replacement));return value;}
    pair(index){return this.labels.pair[index] || String(index+1);}
    money(cents){try{return new Intl.NumberFormat(this.config.locale || 'en',{style:'currency',currency:this.config.currency || 'USD'}).format(cents/100);}catch{return `${this.config.currency || ''} ${(cents/100).toFixed(2)}`;}}
    selectedCount(){return this.slots.filter(slot=>this.complete(slot)).length;}
    rateForCount(count){if(count<1)return 0;return count===1&&!this.useCode?0:this.rates[Math.min(count,3)-1] || 0;}
    rate(){return this.rateForCount(this.selectedCount());}
    previewCount(index){return this.slots.filter((slot,i)=>i!==index&&this.complete(slot)).length+1;}
    previewRate(index){return this.rateForCount(this.previewCount(index));}
    previewTotal(index,variant){const subtotal=this.slots.reduce((sum,slot,i)=>sum+(i!==index&&this.complete(slot)?this.variant(slot).price:0),0)+(variant?.price || 0);return discountPrice(subtotal,this.previewRate(index));}
    product(slot){return slot?this.products.get(slot.productId):null;}
    variant(slot){return this.product(slot)?.variants.find(v=>v.id===slot.variantId);}
    complete(slot){return Boolean(slot&&purchasable(this.variant(slot)));}
    fingerprint(){return JSON.stringify(this.slots.map(slot=>slot?[slot.productId,slot.variantId]:null));}
    ready(){return this.slots.length>0&&this.slots.every(slot=>this.complete(slot));}
    status(message,error=false){const node=this.querySelector('[data-bb-status]');node.textContent=message;node.dataset.error=String(error);}
    modalStatus(message){this.querySelector('[data-bb-dialog-status]').textContent=message;}
    totals(){const count=this.selectedCount();const original=this.slots.reduce((sum,slot)=>sum+(this.complete(slot)?this.variant(slot).price:0),0);const rate=this.rateForCount(count);return {original,discounted:discountPrice(original,rate),count,rate};}
    optionChoices(product,options,index){return product.options[index].values.map(value=>({value,available:product.variants.some(v=>purchasable(v)&&v.options[index]===value&&matches(v,options,index))}));}
    slotOptions(product,slot,index){
      if(product.hasDefault)return '';
      return `<div class="bb-slot-options">${product.options.map((option,optionIndex)=>{
        const value=slot.options[optionIndex] || '';
        return `<label class="bb-select-label"><span>${esc(option.name)}</span><select data-bb-slot-option="${optionIndex}" data-bb-slot="${index}" ${this.busy?'disabled':''}>${!value?`<option value="">${esc(this.t('pickOptions'))}</option>`:''}${this.optionChoices(product,slot.options,optionIndex).map(choice=>`<option value="${esc(choice.value)}" ${choice.value===value?'selected':''} ${!choice.available?'disabled':''}>${esc(choice.value)}${!choice.available?' — '+esc(this.t('soldOut')):''}</option>`).join('')}</select></label>`;
      }).join('')}</div>`;
    }
    slotImage(product,slot){const candidate=this.variant(slot) || product.variants.find(variant=>purchasable(variant)&&matches(variant,slot.options));return sourceURL(candidate?.featured_image) || product.images[0] || '';}
    renderBoard(){
      const list=this.querySelector('[data-bb-slots]');list.dataset.count=String(this.slots.length);
      list.innerHTML=this.slots.map((slot,index)=>{
        const product=this.product(slot);const variant=this.variant(slot);const valid=this.complete(slot);const src=product?this.slotImage(product,slot):index>0?this.config.otherPlaceholder || this.config.placeholder:this.config.placeholder;
        const header=`<div class="bb-card-heading"><span>${esc(this.pair(index))}</span><span class="bb-discount-badge">${esc(this.t('orderBadge',{rate:this.rate()}))}</span></div>`;
        if(!product)return `<article class="bb-card bb-card--empty">${header}<button type="button" class="bb-image-button" data-bb-action="choose" data-bb-slot="${index}" ${this.busy?'disabled':''} aria-label="${esc(this.labels.choose[index])}">${src?`<img src="${esc(imageURL(src,650))}" alt="" loading="lazy" width="600" height="750">`:''}<span class="bb-placeholder-mark"><span aria-hidden="true">+</span><b>${esc(this.labels.choose[index])}</b></span></button><p class="bb-empty-note">${esc(this.t('empty'))}</p>${index>0?`<div class="bb-card-actions"><span></span><button type="button" class="bb-remove" data-bb-action="remove" data-bb-slot="${index}" aria-label="${esc(this.t('remove'))}" ${this.busy?'disabled':''}>×</button></div>`:''}</article>`;
        return `<article class="bb-card">${header}<button type="button" class="bb-image-button" data-bb-action="choose" data-bb-slot="${index}" aria-label="${esc(this.t('edit')+': '+product.title)}" ${this.busy?'disabled':''}>${src?`<img src="${esc(imageURL(src,650))}" alt="${esc(product.title)}" width="600" height="750" loading="lazy">`:`<span class="bb-placeholder-mark"><span>?</span></span>`}</button><h3 class="bb-product-title" title="${esc(product.title)}">${esc(product.title)}</h3>${this.slotOptions(product,slot,index)}<p class="bb-slot-price">${valid?`<strong>${esc(this.money(variant.price))}</strong>`:`<strong>${esc(this.t('emptyPrice'))}</strong>`}</p><p class="bb-price-caption">${esc(valid?this.t('estimated'):this.t('optionNeeded'))}</p><div class="bb-card-actions"><button type="button" class="bb-text-button" data-bb-action="choose" data-bb-slot="${index}" ${this.busy?'disabled':''}>${esc(this.t('edit'))}</button><button type="button" class="bb-remove" data-bb-action="remove" data-bb-slot="${index}" aria-label="${esc(this.t('remove'))}" ${this.busy?'disabled':''}>×</button></div></article>`;
      }).join('');
      this.querySelector('[data-bb-count]').textContent=`${this.totals().count} / 3`;
      this.querySelector('[data-bb-add-wrap]').innerHTML=this.slots.length<3?`<button type="button" class="bb-add-slot" data-bb-action="add-slot" ${!this.ready()||this.busy?'disabled':''}><span aria-hidden="true">+</span><span>${esc(this.t('add'))}<small>${esc(this.ready()?this.t('nextOffer',{rate:this.rates[this.slots.length]}):this.t('finishFirst'))}</small></span></button>`:`<p class="bb-price-caption">${esc(this.t('full'))}</p>`;
      const total=this.totals();const already=this.lastAdded===this.fingerprint();
      const label=this.busy?this.t('adding'):this.uncertain?this.t('refresh'):already?this.t('addedButton'):this.ready()?this.t('addCart'):total.count?this.t('selectOptions'):this.t('noSelection');
      this.querySelector('[data-bb-summary]').innerHTML=`${this.config.code&&total.count<=1?`<label class="bb-code-check"><input type="checkbox" data-bb-first-code ${this.useCode?'checked':''} ${this.busy?'disabled':''}><span>${esc(this.t('firstCode',{code:this.config.code,rate:this.rates[0]}))}</span></label>`:total.count>1?`<p class="bb-summary-note">${esc(this.t('noStack',{rate:total.rate}))}</p>`:''}<div class="bb-summary-line"><span>${esc(this.t('original'))}</span><s>${esc(this.money(total.original))}</s></div><div class="bb-summary-line"><span>${esc(this.t('orderRate',{count:total.count}))}</span><strong data-bb-order-rate>${total.rate}%</strong></div><div class="bb-summary-line"><span>${esc(this.t('saving'))}</span><span>${esc(this.money(total.original-total.discounted))}</span></div><div class="bb-summary-line bb-summary-line--total"><span>${esc(this.t('total'))}</span><strong data-bb-total>${esc(this.money(total.discounted))}</strong></div><p class="bb-summary-note">${esc(this.t('estimateNote',{code:this.config.code}))}</p><button type="button" class="bb-primary" data-bb-action="add-cart" ${!this.ready()||this.busy||this.uncertain||already?'disabled':''}>${esc(label)}</button>`;
    }
    onClick(event){
      const button=event.target.closest('[data-bb-action]');if(!button||!this.contains(button)||button.disabled)return;
      const action=button.dataset.bbAction;const index=Number(button.dataset.bbSlot);
      if(action==='choose'){this.returnTarget=button;this.openPicker(index);}
      else if(action==='remove'&&!this.busy){this.slots.splice(index,1);if(!this.slots.length)this.slots=[null];this.renderBoard();this.status(this.t('changed'));}
      else if(action==='add-slot'&&!this.busy&&this.slots.length<3&&this.ready()){this.slots.push(null);this.renderBoard();this.openPicker(this.slots.length-1);}
      else if(action==='close')this.closePicker();
      else if(action==='product')this.openProduct(button.dataset.bbProduct);
      else if(action==='back'){this.productRequest?.abort();this.showCatalog();}
      else if(action==='option')this.setDetailOption(Number(button.dataset.bbOption),button.dataset.bbValue);
      else if(action==='confirm')this.confirmProduct();
      else if(action==='thumb'){this.galleryIndex=Number(button.dataset.bbImage);this.renderGallery();}
      else if(action==='gallery-prev')this.moveGallery(-1);
      else if(action==='gallery-next')this.moveGallery(1);
      else if(action==='load-more')this.loadMore();
      else if(action==='copy-code')this.copyCode();
      else if(action==='add-cart')this.addBundle();
    }
    onChange(event){
      if(this.busy)return;
      const select=event.target.closest('[data-bb-slot-option]');
      if(select){const index=Number(select.dataset.bbSlot),optionIndex=Number(select.dataset.bbSlotOption),slot=this.slots[index],product=this.product(slot);if(!product)return;slot.options=changeOption(product,slot.options,optionIndex,select.value);slot.variantId=exactVariant(product,slot.options)?.id || null;this.renderBoard();this.querySelector(`[data-bb-slot="${index}"][data-bb-slot-option="${optionIndex}"]`)?.focus();this.status(this.t('changed'));}
      else if(event.target.matches('[data-bb-first-code]')){this.useCode=event.target.checked;this.renderBoard();this.querySelector('[data-bb-first-code]')?.focus();this.status(this.t('changed'));}
    }
    openPicker(index){
      if(this.busy)return;this.activeIndex=index;this.modalStatus('');this.querySelector('[data-bb-search]').value='';this.showCatalog();
      this.oldOverflow=document.body.style.overflow;document.body.style.overflow='hidden';
      if(!this.dialog.open)this.dialog.showModal();
      const slot=this.slots[index];if(slot)this.openProduct(slot.productId);else this.querySelector('[data-bb-search]')?.focus();
    }
    closePicker(){this.productRequest?.abort();if(this.dialog.open)this.dialog.close();this.restoreScroll();}
    restoreScroll(){if(this.oldOverflow!==undefined){document.body.style.overflow=this.oldOverflow;delete this.oldOverflow;}}
    restoreFocus(){const node=this.returnTarget?.isConnected?this.returnTarget:this.querySelector(`[data-bb-action="choose"][data-bb-slot="${this.activeIndex}"]`);node?.focus({preventScroll:true});}
    showCatalog(){
      this.detailProduct=null;this.querySelector('[data-bb-catalog-view]').hidden=false;this.querySelector('[data-bb-detail-view]').hidden=true;
      this.querySelector('[data-bb-dialog-title]').textContent=this.t('chooseTitle');
      this.querySelector('[data-bb-dialog-kicker]').textContent=this.t('slotKicker',{pair:this.pair(this.activeIndex),rate:this.previewRate(this.activeIndex)});
      this.modalStatus('');this.renderCatalog();
    }
    renderCatalog(){
      const query=this.querySelector('[data-bb-search]').value.trim().toLocaleLowerCase();
      const products=[...this.products.values()].filter(p=>p.title.toLocaleLowerCase().includes(query));
      this.querySelector('[data-bb-catalog-count]').textContent=this.t('loaded',{count:this.products.size,total:Math.max(Number(this.config.total)||0,this.products.size)});
      this.querySelector('[data-bb-products]').innerHTML=products.length?products.map(product=>{
        const variants=product.variants.filter(purchasable);const lowest=variants.length?Math.min(...variants.map(v=>v.price)):null;const src=product.images[0];
        return `<button type="button" class="bb-catalog-card" data-bb-action="product" data-bb-product="${esc(product.id)}" title="${esc(product.title)}">${src?`<img src="${esc(imageURL(src,400))}" alt="${esc(product.title)}" width="400" height="440" loading="lazy">`:`<span class="bb-no-results" aria-hidden="true">?</span>`}<span class="bb-catalog-name">${esc(product.title)}</span><strong>${lowest!=null?`${esc(this.money(lowest))}`:esc(this.t('soldOut'))}</strong><span>${lowest!=null?esc(this.t('from')+' · '+this.t('estimateCatalog')):''}</span></button>`;
      }).join(''):`<p class="bb-no-results">${esc(this.t(this.products.size?'noResults':'emptyCatalog'))}</p>`;
      const button=this.querySelector('[data-bb-action="load-more"]');button.hidden=!this.next;button.disabled=Boolean(this.loadingMore);button.textContent=this.t(this.loadingMore?'loading':'loadMore');
    }
    async getJSON(url,options={}){
      const response=await fetch(url,{credentials:'same-origin',...options});let data;
      try{data=await response.json();}catch{const error=new Error(this.t('network'));error.httpStatus=response.status;throw error;}
      if(!response.ok || Number(data?.status)>=400){const error=new Error(data.description || data.message || this.t('error'));error.httpStatus=response.status;throw error;}
      return data;
    }
    async loadMore(){
      if(!this.next||this.loadingMore)return;this.loadingMore=true;this.modalStatus('');this.renderCatalog();
      try{
        const url=new URL(this.next,location.href);if(url.origin!==location.origin)throw Error(this.t('network'));url.searchParams.set('section_id',this.config.sectionId);
        if(this.visitedPages.has(url.href)){this.next='';return;}
        const response=await fetch(url.href,{credentials:'same-origin',signal:this.life.signal});if(!response.ok)throw Error(this.t('network'));
        const documentHTML=new DOMParser().parseFromString(await response.text(),'text/html');let data;
        for(const node of documentHTML.querySelectorAll('[data-bb-catalog]')){const parsed=decodeCatalog(node);if(parsed.collection===this.config.collection){data=parsed;break;}}
        if(!data)throw Error(this.t('network'));
        this.visitedPages.add(url.href);for(const raw of data.products||[]){const product=normalise(raw);this.products.set(product.id,product);}this.next=data.next || '';this.config.total=data.total;
      }catch(error){if(error.name!=='AbortError')this.modalStatus(error.message || this.t('network'));}
      finally{this.loadingMore=false;if(this.isConnected)this.renderCatalog();}
    }
    async openProduct(id){
      const initial=this.products.get(String(id));if(!initial)return;
      this.productRequest?.abort();this.productRequest=new AbortController();const request=this.productRequest;
      this.modalStatus(this.t('productLoading'));
      try{
        const raw=await this.getJSON(this.root+'products/'+encodeURIComponent(initial.handle)+'.js',{signal:request.signal});
        if(request!==this.productRequest||!this.dialog.open)return;
        const product=normalise(raw);if(product.id!==initial.id)throw Error(this.t('network'));this.products.set(product.id,product);this.detailProduct=product;
        const existing=this.slots[this.activeIndex];const first=product.variants.find(purchasable) || product.variants[0];
        this.detailOptions=existing?.productId===product.id?[...existing.options]:[...(first?.options || [])];
        if(existing?.productId!==product.id&&!product.hasDefault)product.options.forEach((option,i)=>{if(isSize(option.name))this.detailOptions[i]='';});
        this.galleryIndex=0;this.syncVariantImage();this.querySelector('[data-bb-catalog-view]').hidden=true;this.querySelector('[data-bb-detail-view]').hidden=false;
        this.querySelector('[data-bb-dialog-title]').textContent=this.pair(this.activeIndex);this.renderDetail();this.modalStatus('');
        this.querySelector('[data-bb-action="back"]')?.focus();
      }catch(error){if(error.name!=='AbortError')this.modalStatus(this.t('network'));}
    }
    detailVariant(){return exactVariant(this.detailProduct,this.detailOptions || []);}
    syncVariantImage(){
      const product=this.detailProduct;if(!product)return;
      const variant=this.detailVariant() || product.variants.find(v=>purchasable(v)&&matches(v,this.detailOptions));
      const src=sourceURL(variant?.featured_image);if(!src)return;
      let index=product.images.findIndex(image=>image.split('?')[0]===src.split('?')[0]);
      if(index<0){product.images.push(src);index=product.images.length-1;}this.galleryIndex=index;
    }
    setDetailOption(index,value){
      if(!this.detailProduct)return;this.detailOptions=changeOption(this.detailProduct,this.detailOptions,index,value);this.syncVariantImage();
      const scroll=this.dialog.scrollTop;this.renderDetail();this.dialog.scrollTop=scroll;
      [...this.querySelectorAll('[data-bb-action="option"]')].find(b=>Number(b.dataset.bbOption)===index&&b.dataset.bbValue===value)?.focus({preventScroll:true});
    }
    renderDetail(){
      const product=this.detailProduct;if(!product)return;const variant=this.detailVariant();
      const groups=product.hasDefault?'':product.options.map((option,index)=>`<fieldset class="bb-option-group"><legend>${esc(option.name)}${this.detailOptions[index]?`: ${esc(this.detailOptions[index])}`:''}</legend><div class="bb-option-buttons">${this.optionChoices(product,this.detailOptions,index).map(choice=>`<button type="button" class="bb-option-button" data-bb-action="option" data-bb-option="${index}" data-bb-value="${esc(choice.value)}" aria-pressed="${choice.value===this.detailOptions[index]}" ${!choice.available?'disabled':''}>${esc(choice.value)}</button>`).join('')}</div></fieldset>`).join('');
      const available=product.variants.some(purchasable);
      this.querySelector('[data-bb-detail-view]').innerHTML=`<button type="button" class="bb-detail-back" data-bb-action="back">${esc(this.t('back'))}</button><div class="bb-detail-layout"><div class="bb-gallery" data-bb-gallery></div><div class="bb-detail-info"><h4>${esc(product.title)}</h4><p class="bb-detail-price">${variant?`<strong>${esc(this.money(variant.price))}</strong>`:`<strong>${esc(this.t(available?'emptyPrice':'soldOut'))}</strong>`}</p><p class="bb-detail-estimate">${esc(variant?this.t('slotKicker',{pair:this.pair(this.activeIndex),rate:this.previewRate(this.activeIndex)})+' · '+this.t('previewTotal')+': '+this.money(this.previewTotal(this.activeIndex,variant)):this.t(available?'optionNeeded':'unsupported'))}</p>${groups}<button type="button" class="bb-primary bb-detail-choose" data-bb-action="confirm" ${!variant?'disabled':''}>${esc(this.t(variant?'confirm':available?'pickOptions':'soldOut'))}</button><a class="bb-product-link" href="${esc(this.root+'products/'+encodeURIComponent(product.handle))}" target="_blank" rel="noopener">${esc(this.t('productPage'))} ↗</a></div></div>`;
      this.renderGallery();
    }
    renderGallery(){
      const product=this.detailProduct,node=this.querySelector('[data-bb-gallery]');if(!product||!node)return;
      if(!product.images.length){node.innerHTML=`<div class="bb-gallery-stage"><p class="bb-no-results">${esc(this.t('imageMissing'))}</p></div>`;return;}
      this.galleryIndex=(this.galleryIndex+product.images.length)%product.images.length;
      const vars={index:this.galleryIndex+1,total:product.images.length};
      node.innerHTML=`<div class="bb-gallery-stage"><img src="${esc(imageURL(product.images[this.galleryIndex],1100))}" alt="${esc(product.title+' — '+this.t('allImages',vars))}" width="900" height="900">${product.images.length>1?`<button type="button" class="bb-gallery-arrow bb-gallery-arrow--prev" data-bb-action="gallery-prev" aria-label="${esc(this.t('prevImage'))}">‹</button><button type="button" class="bb-gallery-arrow bb-gallery-arrow--next" data-bb-action="gallery-next" aria-label="${esc(this.t('nextImage'))}">›</button>`:''}</div><div class="bb-thumbnails">${product.images.map((src,index)=>`<button type="button" class="bb-thumbnail" data-bb-action="thumb" data-bb-image="${index}" aria-current="${index===this.galleryIndex}" aria-label="${esc(this.t('imageNumber',{index:index+1}))}"><img src="${esc(imageURL(src,120))}" alt="" width="57" height="57" loading="lazy"></button>`).join('')}</div><p class="bb-gallery-count">${esc(this.t('allImages',vars))}</p>`;
    }
    moveGallery(direction){if(!this.detailProduct?.images.length)return;this.galleryIndex+=direction;this.renderGallery();}
    confirmProduct(){
      const product=this.detailProduct,variant=this.detailVariant();if(!product||!variant)return;
      this.slots[this.activeIndex]={productId:product.id,variantId:variant.id,options:[...variant.options]};this.renderBoard();this.closePicker();this.status(this.t('chosen'));
    }
    async copyCode(){try{if(!navigator.clipboard||!window.isSecureContext)throw Error('unavailable');await navigator.clipboard.writeText(this.config.code);this.status(this.t('copySuccess'));}catch{this.status(this.t('copyFallback',{code:this.config.code}));}}
    async refreshSelectedProducts(){
      const ids=[...new Set(this.slots.map(slot=>slot.productId))];let changed=false;
      const fresh=await Promise.all(ids.map(async id=>{const old=this.products.get(id);return normalise(await this.getJSON(this.root+'products/'+encodeURIComponent(old.handle)+'.js',{signal:this.life.signal}));}));
      for(const product of fresh){const old=this.products.get(product.id);if(!old)throw Error(this.t('network'));for(const slot of this.slots.filter(s=>s.productId===product.id)){const before=old.variants.find(v=>v.id===slot.variantId),after=product.variants.find(v=>v.id===slot.variantId);if(!purchasable(after)||before?.price!==after?.price){changed=true;if(!purchasable(after))slot.variantId=null;}}this.products.set(product.id,product);}
      return changed;
    }
    cartCodes(cart){
      const codes=(cart.discount_codes || []).map(code=>typeof code==='string'?code:code.code).filter(Boolean);
      for(const app of cart.cart_level_discount_applications || [])if(app.type==='discount_code'&&app.title)codes.push(app.title);
      for(const item of cart.items || [])for(const allocation of item.line_level_discount_allocations || []){const app=allocation.discount_application;if(app?.type==='discount_code'&&app.title)codes.push(app.title);}
      return [...new Map(codes.map(code=>[String(code).toUpperCase(),String(code)])).values()];
    }
    groupState(cart,group,expected){
      const items=(cart?.items || []).filter(item=>item.properties?._WelcomeBundle===group);
      const full=expected.every(planned=>items.filter(item=>String(item.variant_id || item.id)===String(planned.id)&&String(item.properties?._WelcomeSlot)===planned.properties._WelcomeSlot).reduce((sum,item)=>sum+Number(item.quantity || 0),0)===planned.quantity);
      return {any:items.length>0,full};
    }
    renderCartResult(cart,message){
      const box=this.querySelector('[data-bb-cart-result]');box.hidden=false;
      box.innerHTML=`<p>${esc(message)}</p>${cart&&Number.isFinite(cart.total_price)?`<p><strong>${esc(this.t('cartTotal'))}: ${esc(this.money(cart.total_price))}</strong></p><p class="bb-price-caption">${esc(this.t('cartOther'))}</p>`:''}<a href="${esc(this.root+'cart')}">${esc(this.t('viewCart'))} →</a>`;
    }
    async addBundle(){
      if(this.busy||this.uncertain||!this.ready()||this.lastAdded===this.fingerprint())return;
      this.busy=true;this.status('');this.querySelector('[data-bb-cart-result]').hidden=true;this.renderBoard();
      let cart=null,confirmed=false;const fingerprint=this.fingerprint();const group=globalThis.crypto?.randomUUID?.() || `welcome-${Date.now()}-${Math.random().toString(16).slice(2)}`;
      try{
        if(await this.refreshSelectedProducts()){this.status(this.t('priceUpdated'),true);return;}
        const items=this.slots.map((slot,index)=>({id:slot.variantId,quantity:1,properties:{_WelcomeBundle:group,_WelcomeSlot:String(index+1),...(index===0&&this.slots.length===1&&this.useCode&&this.config.code?{_WelcomeCode:this.config.code}:{})}}));
        try{
          await this.getJSON(this.root+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items}),signal:this.life.signal});confirmed=true;
        }catch(error){
          try{cart=await this.getJSON(this.root+'cart.js',{cache:'no-store'});}catch{}
          const state=this.groupState(cart,group,items);
          if(state.full)confirmed=true;
          else if(state.any){this.uncertain=true;this.renderCartResult(cart,this.t('partial'));this.status(this.t('partial'),true);return;}
          else if(cart&&error.httpStatus>=400){this.status(error.message || this.t('error'),true);return;}
          else{this.uncertain=true;this.renderCartResult(cart,this.t('uncertain'));this.status(this.t('uncertain'),true);return;}
        }
        if(confirmed){
          this.lastAdded=fingerprint;let message=this.t('added');
          try{
            cart=cart || await this.getJSON(this.root+'cart.js',{cache:'no-store'});
            const applySingleCode=this.slots.length===1&&this.useCode&&Boolean(this.config.code);
            if(this.config.code){
              try{
                const existing=this.cartCodes(cart),same=code=>code.toUpperCase()===String(this.config.code).toUpperCase();
                const codes=applySingleCode?[...existing.filter(code=>!same(code)),this.config.code]:existing.filter(code=>!same(code));
                if(applySingleCode||codes.length!==existing.length){
                  cart=await this.getJSON(this.root+'cart/update.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({discount:codes.join(',')})});
                }
                if(applySingleCode){const codeState=(cart.discount_codes || []).find(code=>same(String(code.code)));if(codeState?.applicable===false)message=this.t('codeNotApplicable');}
              }catch{message=this.t('codeFailed');}
            }
            if(cart.currency)this.config.currency=cart.currency;
            this.dispatchEvent(new CustomEvent('welcome-bundle:added',{bubbles:true,detail:{cart,group}}));
            document.dispatchEvent(new CustomEvent('cart:updated',{bubbles:true,detail:{cart}}));
            document.dispatchEvent(new CustomEvent('cart:refresh',{bubbles:true,detail:{cart}}));
          }catch{message=this.t('cartUnknown');}
          this.renderCartResult(cart,message);this.status(message);
        }
      }catch(error){if(error.name!=='AbortError')this.status(error.message || this.t('error'),true);}
      finally{this.busy=false;if(this.isConnected)this.renderBoard();}
    }
  }
  customElements.define('welcome-edit-section',WelcomeBundleBuilder);
})();

  } catch(e) { console.error(e); }
})();
})();
